<template>
  <div
    v-on-clickaway="close"
    :class="classes"
  >
    <div class="select__field-wrapper" @click="onActivate">
      <label
        v-if="label"
        :for="id"
        class="select__label"
      >
        {{ label }}
        <span v-if="required" class="select__label-required">*</span>
      </label>

      <div class="select__field">
        <div
          :class="[
            'select__text',
            { 'select__text-placeholder' : text === placeholder },
            { 'select__text_padding' : itemsLength === 0 || items.length < 1}
          ]"
        >
          {{ text }}
        </div>
        <ChevronIcon v-if="items.length > 0 && itemsLength !== 0 && !desabled" class="select__arrow" />
      </div>
    </div>

    <div :class="['select__dropdown', `select__dropdown_scrollbar_${scrollbar}`]">
      <div
        v-for="(item, index) in filteredItems"
        :key="`select-item-${index}-in-${id}`"
        class="select__dropdown-item"
        @click="onItemSelect(item)"
      >
        {{ item[itemTextKey] }}
      </div>
    </div>

    <transition
      name="slide-from-top"
      @enter="errorEnter"
      @beforeLeave="errorBeforeLeave"
      @leave="errorLeave"
    >
      <span
        v-if="error && errorMsg"
        class="select__error-msg"
      >
        {{ errorMsg }}
      </span>
    </transition>
  </div>
</template>

<script>
  import ChevronIcon from '@/assets/img/icons/chevron.svg?inline'
  import { mixin as clickaway } from 'vue-clickaway'
  import { get } from 'lodash'

  export default {
    name: 'BaseSelect',
    components: {
      ChevronIcon
    },

    mixins: [ clickaway ],

    props: {
      colIndex: {
        type: Number,
        default: null
      },
      value: {
        type: null,
        default: ''
      },
      required: {
        type: Boolean,
        default: false
      },
      label: {
        type: String,
        default: ''
      },
      placeholder: {
        type: String,
        default: ''
      },
      items: {
        type: Array,
        requied: true
      },
      itemValueKey: {
        type: String,
        default: 'value'
      },
      itemTextKey: {
        type: String,
        default: 'text'
      },
      errorMsg: {
        type: String,
        default: ''
      },
      scrollbar: {
        type: String,
        default: 'custom'
      },
      desabled: {
        type: Boolean,
        default: false
      },
      selectFirstItem: {
        type: Boolean,
        default: false
      },
      model: {
        type: Number,
        default: null
      },
      needActive: {
        type: Boolean,
        default: false
      }
    },

    data () {
      return {
        selected: null,
        isActive: false,
        error: null,
        forcedItem: {},
        itemsLength: null,
        marginBottom: 0
      }
    },

    computed: {
      id () {
        return `select-${this._uid}`
      },
      text () {
        return get(this, ['selected', this.itemTextKey]) || this.placeholder
      },
      classes () {
        return [
          'select',
          {
            'select_active': this.isActive,
            'select_error': this.error,
            'select_disable': this.desabled,
            'select_no-items': this.itemsLength === 0 || this.items.length < 1
          }
        ]
      },
      filteredItems () {
        return this.items.filter(item => item.value !== get(this, 'selected.value'))
      }
    },

    watch: {
      items: {
        immediate: true,
        handler (newVal) {
          if (this.items.filter((item) => item.value).length === 1 && this.items.filter((item) => item.value)[0].value) {
            setTimeout(() => {
              this.onItemSelect(this.items.filter((item) => item.value)[0])
            })
          }
        }
      },
      // '$route.query' (newVal, oldVal) {
      //   if (this.watchQuery) {
      //     if (newVal[this.name] !== oldVal[this.name]) { this.$emit('input', newVal[this.name]) }
      //   }
      // },
      value: {
        handler (v) {
          const filetedItems = this.items.filter(item => item[this.itemValueKey] === this.value)
          this.onItemSelect(filetedItems.length && filetedItems[0].value
            ? filetedItems[0]
            : this.placeholder || this.items[0] // placeholder or first
          )
        },
        immediate: true
      },
      errorMsg: {
        handler (msg) {
          this.error = !!msg
        },
        immediate: true
      }
      // $route (to) {
      //   if (this.selectFirstItem) {
      //     this.filteredItems.forEach(el => {
      //       if (el.value === to.params.model) {
      //         this.forcedItem = el
      //         this.onItemSelect(this.forcedItem)
      //       }
      //     })
      //   }
      // }
    },

    mounted () {
      this.marginBottom = parseInt(getComputedStyle(this.$el).marginBottom)

      // if (this.selectFirstItem) {
      //   this.filteredItems.forEach(el => {
      //     if (Number(el.value) === this.model) {
      //       this.forcedItem = el
      //       this.onItemSelect(this.forcedItem)
      //     }
      //   })
      // }
    },
    methods: {
      onActivate () {
        if (this.desabled) return

        this.isActive = !this.isActive

        if (this.needActive) {
          this.$emit('isOpen', this.isActive)
        }

        this.error = false
      },

      onItemSelect (item) {
        this.selected = item
        this.$emit('input', this.selected[this.itemValueKey], this.colIndex)

        this.close()

        this.itemsLength = this.filteredItems.length
      },

      close () {
        this.isActive = false
      },

      errorEnter (el, done) {
        // first appear
        this.setErrorMargin(el, done, this.getErrorHeight(el))

        // second change innerText
        // watch on error
        this.unwatchError = this.$watch('error', () => {
          this.$nextTick(() => this.setErrorMargin(this.getErrorHeight(el)))
        })
      },

      errorBeforeLeave () {
        // unwatch error changes before error leave
        this.unwatchError()
      },

      errorLeave (el, done) {
        this.setErrorMargin(el, done, this.marginBottom)
      },

      setErrorMargin (el, done, marginBottom) {
        this.$el.style.marginBottom = `${marginBottom}px`
        done()
      },

      getErrorHeight (el) {
        const scrollHeight = (el && el.scrollHeight) || 0
        return scrollHeight > this.marginBottom ? scrollHeight : this.marginBottom
      }
    }
  }
</script>

<style lang="scss">
  $padding-for-error: 25px;
  $active-box-shadow: 2px 2px 5px rgba($c-black, 0.1);

  .select {
    position: relative;
    display: block;
    min-width: 323px;
    max-width: 323px;
    padding-bottom: $padding-for-error;
    cursor: pointer;

    @include mobile {
      max-width: 100%;
      padding-bottom: 20px;
    }

    &__label {
      display: inline-block;
      padding-bottom: 8px;
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      color: $c-black;

      &-required {
        color: $c-active-light;
      }
    }

    &__text {
      padding-right: 14px;
      color: $c-black;

      &_padding {
        padding-right: 0;
      }

      &-placeholder {
        color: rgba($c-black, 0.5);
      }
    }

    &__field {
      position: relative;
      display: block;
      width: 100%;
      padding: 14px 22px 12px 18px;
      font-family: "FavoritC", Arial, Helvetica, sans-serif;
      font-size: 16px;
      line-height: 24px;
      background-color: $c-white;
      border: 1px solid $c-gray-medium;
      outline: none;
      transition: all 0.3s;
      caret-color: $c-black;

      &:focus {
        border: 1px solid $c-black;
      }

      @include hover {
        // background-color: $c-gray;
      }
    }

    &__arrow {
      position: absolute;
      right: 22px;
      bottom: 42%;
      width: 14px;
      height: 7px;
      overflow: visible;
      transition: 0.3s;
    }

    &__dropdown {
      position: absolute;
      // top: calc(100% - #{$padding-for-error});
      top: 83px;
      left: 0;
      z-index: 999;
      width: 100%;
      max-height: 160px;
      overflow-y: auto;
      font-family: "FavoritC", Arial, Helvetica, sans-serif;
      visibility: hidden;
      opacity: 0;

      &_scrollbar {
        &_custom {
          @include custom-scrollbar();
        }

        &_none {
          @include no-scrollbar();
        }
      }

      &-item {
        padding: 14px 18px;
        font-size: 16px;
        line-height: 24px;
        color: $c-black;
        background-color: $c-white;

        &:not(:last-child) {
          border-bottom: 1px solid $c-gray-medium;
        }
      }
    }

    &__error-msg {
      position: absolute;
      top: 82%;
      left: 0;
      font-size: 14px;
      line-height: 20px;
      color: $c-active;
    }

    &_error {
      .select {
        &__field {
          border-color: $c-active;
        }
      }
    }

    &_no-items {
      pointer-events: none;
    }

    &_active {
      .select {
        &__field {
          border: 1px solid $c-black;
        }

        &__text {
          color: $c-black;
        }

        &__arrow {
          transform: rotate(-180deg);
        }

        &__dropdown {
          visibility: visible;
          border: 1px solid $c-black;
          opacity: 1;
        }
      }
    }

    &_disable {
      cursor: default;
    }
  }
</style>
